import declare from "dojo/_base/declare";
import config from "csi/config";
import reflection from "csi/reflection";
import Widget from "csi/table/Widget";
import xml from "csi/xml";

const FISectionTestSpecsController = declare(Widget, {

	/**
	 * Return subtype store of FinalInspectionSection for custom view dialog
	 */
	getCustomViewNodeContextsStore() {
		return config.getSubtypeStore("FinalInspectionSection");
	},

	/**
	 * Assign custom view key
	 */
	_assignPrefContext() {
		const { defView } = this;
		const section = this.getViewNode();
		if (section) {
			const setting: string = reflection.getSubtypeSetting(section.Subtype, "LinkingType");
			this.prefKey = defView.getKey(xml.enumGetText(setting));
		}
	},

	/**
	 * Refresh custom view store and default view
	 */
	refreshWidget() {
		this._assignPrefContext();
		this.refreshDefaultCustomView(true);
	},

	_resolveView() {
		this._assignPrefContext();
		this.inherited(arguments);
	},
});

export = FISectionTestSpecsController;